<script setup lang="ts">
defineOptions({
	name: 'TechnicalSection',
})

const { t: $t, locale } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-material-symbols:settings-outline-rounded"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Technical, Organisational, and Safety measures implemented') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						`To ensure the security and strict confidentiality of Users' Personal Data, Gaveta Decimal processes all provided information with absolute discretion, in line with internal security and confidentiality policies and procedures, which are periodically updated as needed and in accordance with legal requirements`,
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'Taking into account the nature, scope, context, and purpose of the Personal Data processing, as well as potential risks to the rights and freedoms of the Data Subjects, Gaveta Decimal commits to implementing appropriate technical and organisational measures both at the initial stage of defining the means of processing and throughout the processing itself',
					)
				}}.
			</p>

			<p>
				{{ $t('In general, Gaveta Decimal adopts the following security measures') }}{{ locale === 'fr' ? ' :' : ':' }}
			</p>

			<ul class="list-disc pl-7 space-y-2.5">
				<li>
					{{ $t('Regular audits to evaluate the effectiveness of technical and organisational measures in place') }}.
				</li>

				<li>
					{{ $t('Ongoing awareness-raising and training for staff involved in Personal Data Processing activities') }}.
				</li>

				<li>{{ $t('Pseudonymisation and encryption of Personal Data, where justified') }}.</li>

				<li>
					{{
						$t(
							'Mechanisms that guarantee the ongoing confidentiality, availability, integrity, and resilience of information systems',
						)
					}}.
				</li>

				<li>
					{{
						$t(
							'Systems to restore information systems and access to Personal Data promptly in the event of a physical or technical incident',
						)
					}}.
				</li>
			</ul>
		</div>
	</section>
</template>
